import React, { Fragment, useMemo, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { FiCornerDownLeft, FiSearch } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

function CommandPalette({ open, onClose, entries }) {
  const navigate = useNavigate()
  const [query, setQuery] = useState('')
  const pages = useMemo(() => entries.filter((entry) => entry.to), [entries])
  const filtered = pages.filter((entry) => entry.label.toLowerCase().includes(query.trim().toLowerCase()))
  const select = (entry) => {
    onClose()
    navigate(entry.to)
  }

  return (
    <Transition show={open} as={Fragment} afterLeave={() => setQuery('')}>
      <Dialog as='div' className='tw-relative tw-z-[110]' onClose={onClose}>
        <Transition.Child as={Fragment} enter='tw-transition-opacity tw-duration-150' enterFrom='tw-opacity-0' enterTo='tw-opacity-100' leave='tw-transition-opacity tw-duration-100' leaveFrom='tw-opacity-100' leaveTo='tw-opacity-0'>
          <div aria-hidden='true' className='tw-fixed tw-inset-0 tw-bg-ink/40' />
        </Transition.Child>
        <div className='tw-fixed tw-inset-0 tw-overflow-y-auto tw-px-4 tw-pt-[12vh]'>
          <Dialog.Panel className='tw-mx-auto tw-w-full tw-max-w-xl tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-pop'>
            <Dialog.Title className='tw-sr-only'>Search superadmin pages</Dialog.Title>
            <div className='tw-flex tw-items-center tw-gap-3 tw-border-b tw-border-line tw-px-4'>
              <FiSearch className='tw-h-5 tw-w-5 tw-text-inkFaint' />
              <input autoFocus aria-label='Search superadmin pages' value={query} onChange={(event) => setQuery(event.target.value)} onKeyDown={(event) => { if (event.key === 'Escape') onClose(); if (event.key === 'Enter' && filtered[0]) select(filtered[0]) }} placeholder='Search superadmin pages' className='tw-h-12 tw-w-full tw-border-0 tw-bg-transparent tw-text-[14px] tw-text-ink placeholder:tw-text-inkFaint focus:tw-outline-none focus:tw-ring-0' />
            </div>
            <div className='tw-max-h-80 tw-overflow-y-auto tw-p-2'>
              {filtered.length ? filtered.map((entry, index) => {
                const Icon = entry.icon
                return <button key={entry.key} type='button' onClick={() => select(entry)} className={`tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-[10px] tw-px-3 tw-py-2 tw-text-left tw-text-[14px] tw-text-ink hover:tw-bg-emberSoft ${index === 0 ? 'tw-bg-sand' : ''}`}><Icon className='tw-h-4 tw-w-4 tw-text-ember' /><span className='tw-flex-1'>{entry.label}</span>{index === 0 && <FiCornerDownLeft className='tw-h-4 tw-w-4 tw-text-inkFaint' />}</button>
              }) : <p className='tw-px-4 tw-py-8 tw-text-center tw-text-[14px] tw-text-inkSoft'>No matching pages</p>}
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </Transition>
  )
}

export default CommandPalette
